import { Box } from '@medely/web-components';
import React from 'react';

const PagePadding = (): React.ReactElement => <Box mt={8} />;

export default PagePadding;
